export const homePageDescriptionText = (): string => {
  return `Create a Scootaverse and customize it with backgrounds, room items, music, entry flows, Smart Badging questions, and more.`;
};
